import { useId, useState } from 'react';
import { mediaUrl } from '../api/client';

export default function TeamCard({ member }) {
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();
  const hasBio = Boolean(member.bio?.trim());

  function toggleBio() {
    setExpanded((open) => !open);
  }

  return (
    <article className={`team-card${expanded ? ' team-card--expanded' : ''}`}>
      <div className="team-card__image-wrap">
        <img
          src={mediaUrl(member.image_url)}
          alt={member.name}
          className="team-card__image"
          loading="lazy"
        />

        {hasBio ? (
          <>
            <button
              type="button"
              className="team-card__toggle"
              aria-expanded={expanded}
              aria-controls={panelId}
              aria-label={
                expanded ? `Cerrar trayectoria de ${member.name}` : `Ver trayectoria de ${member.name}`
              }
              onClick={toggleBio}
            >
              <span className="team-card__toggle-icon" aria-hidden="true" />
            </button>

            <div
              id={panelId}
              className={`team-card__panel${expanded ? ' team-card__panel--open' : ''}`}
              aria-hidden={!expanded}
            >
              <p className="team-card__panel-eyebrow">Trayectoria</p>
              <div className="team-card__panel-scroll">
                <p className="team-card__panel-text">{member.bio}</p>
              </div>
            </div>
          </>
        ) : null}
      </div>

      <div className="team-card__meta">
        <h3 className="team-card__name">{member.name}</h3>
        <p className="team-card__role">{member.role}</p>
      </div>
    </article>
  );
}
